module.exports = __webpack_public_path__ + "media/images/arrows/next-c4aa2ef374d89460d73429e32d00df9c.png";